import { render, staticRenderFns } from "./PurchaseAndSale.vue?vue&type=template&id=ad4f6494&scoped=true&"
import script from "./PurchaseAndSale.vue?vue&type=script&lang=js&"
export * from "./PurchaseAndSale.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAndSale.vue?vue&type=style&index=0&id=ad4f6494&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4f6494",
  null
  
)

export default component.exports